export enum AgentStatus {
  IDLE = 'IDLE',
  RUNNING = 'RUNNING',
}
